import {stringify as urlStringify} from 'query-string';
import {useQuery} from "../../../helpers/hooks/common-hook";
import config from "../../../config";
import {SESSION_ID_KEY} from "../../../consts/common-consts";

/*
Sample Auth Configs
authorizationUrl: "https://bc-store-be-dev-customer-auth.auth.us-east-1.amazoncognito.com/oauth2/authorize",
responseType: "token",
clientId: "7cv8c0uajca33fqqdju1a7rljj",
redirectUri: "http://localhost:3001/auth-callback",
userInfoEndpoint: "https://bc-store-be-dev-customer-auth.auth.us-east-1.amazoncognito.com/oauth2/userInfo",
 */

export default function AuthInit({authConfig}) {
    const query = useQuery();
    const sessionId = query.get(SESSION_ID_KEY);

    const handleOnClickLogin = () => {
        const urlParams = urlStringify({
            "client_id": authConfig.clientId,
            "response_type": 'code',
            "redirect_uri": config.AUTH_CALLBACK_URL,
            "state": sessionId
        });

        const authUrl = `${authConfig.authorizationUrl}?${urlParams}`
        console.log('authUrl', authUrl)
        // window.location.href = `${authConfig.authorizationUrl}?${urlParams}`;
        window.open(authUrl, '_blank', 'width=600,height=600');
    }

    return (
        <div className="px-2 flex flex-col">
            <div className="flex flex-col gap-1 pb-4">
                <span className="text-xs text-gray-400">Please login to continue action</span>
                <button className="rounded-lg bg-white px-4 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 underline" onClick={handleOnClickLogin}>Login</button>
            </div>
        </div>
    )
};